import { apiClient } from '../client'
import type { PaginatedResponse } from './role.repository'

class PogGalleryRepository {
  /** Grouped cards from `bkpis_ai_pog_bay` (store + date + modal_name). */
  async getScanGroups(
    page: number = 1,
    limit: number = 50,
    filters?: PogGalleryScanGroupFilters,
  ): Promise<PaginatedResponse<PogGalleryScanGroupCard>> {
    const params = new URLSearchParams()
    params.set('page', String(page))
    params.set('limit', String(limit))

    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value === undefined || value === null || value === '') continue
        params.set(key, String(value))
      }
    }

    return apiClient.get<PaginatedResponse<PogGalleryScanGroupCard>>(
      `/pog-gallery/groups?${params.toString()}`,
    )
  }

  /** Realogram: typology_key + visit_id → pog_bay images → pog_bay_scans rows. */
  async getScansForCard(query: {
    typology_key: string
    visit_id: number
  }): Promise<PogGalleryScanHistoryRow[]> {
    const params = new URLSearchParams()
    params.set('typology_key', query.typology_key)
    params.set('visit_id', String(query.visit_id))
    return apiClient.get<PogGalleryScanHistoryRow[]>(`/pog-gallery/scans?${params.toString()}`)
  }
}

export type PogGalleryScanGroupFilters = {
  page?: number
  limit?: number
  start_date?: string
  end_date?: string
  store_id?: number
  store_ids?: string
  store_name?: string
  city_ids?: string
  region_ids?: string
  channel_ids?: string
  chain_ids?: string
  store_format_ids?: string
  store_class_ids?: string
  category_ids?: string
  subcategory_ids?: string
  typology_key?: string
  flow?: string
  modal_name?: string
  model_name?: string
  user_id?: number
  tenant_id?: number
  status?: string
  gcs_status?: string
  act_status?: string
  upload_status?: string
  scan_status?: string
}

/** One grouped POG gallery card from `GET /pog-gallery/groups`. */
export interface PogGalleryScanGroupCard {
  planogram: string | null
  visit_id: number | null
  store_name: string | null
  flow: string | null
  total_bays: number
  total_skus: number
  avg_shelves?: number
  total_facings?: number
  pog?: number
  avl_items?: number
  report_date: string | null
}

/** Row from `GET /pog-gallery/scans` (compatible with realogram mapper). */
export interface PogGalleryScanHistoryRow {
  id: number
  bay_no?: number | null
  store_id: number | null
  tenant_id: number | null
  visit_id: number | null
  typology_key: string | null
  model_name: string | null
  image_name: string | null
  image_url?: string | null
  evaluation_id: string | null
  photo_meta: unknown
  request_json: unknown
  response_json: unknown
  our_units_count: number | string | null
  cta?: unknown[] | string | null
  unique_sku_compliance?: unknown[] | string | null
  otherDetails?: {
    last_image_name?: string | null
    total_skus?: number | string | null
    total_facings?: number | string | null
    pog?: number | string | null
    avl_items?: number | string | null
  } | null
  /** JSONB column from `bkpis_ai_pog_bay_scans.our_units`. */
  our_units?: unknown
  our_units_bboxes?: unknown
  unknown_units_count: number | string | null
  unknown_units?: unknown
  unknown_units_bboxes?: unknown
  created_at: string | null
  store_name: string | null
  static_bucket_url?: string | null
  dynamic_bucket_url?: string | null
  sku_photo_by_id?: Record<string, string>
}

export const pogGalleryRepository = new PogGalleryRepository()
